import { FC } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useWorkspaceStore } from "../../../store/workspace/WorkspaceStore";
import { ViewOption } from "../../../types/workspace";
import { CompanyList } from "./CompanyList/CompanyList";
import { CompetitiveAnalysis } from "./CompetitiveAnalysis/CompetitiveAnalysis";
import { MarketLandscape } from "./MarketLandscape/MarketLandscape";

const tabItems = [
  {
    id: "market-landscape-tab",
    label: "MARKET LANDSCAPE",
  },
  {
    id: "competitive-analysis-tab",
    label: "COMPETITIVE ANALYSIS",
  },
  {
    id: "company-list-tab",
    label: "COMPANY LIST",
  },
];

export const View: FC = () => {
  const selectedView = useWorkspaceStore((state) => state.selectedView);
  const setSelectedView = useWorkspaceStore((state) => state.setSelectedView);
  const selectedMarket = useWorkspaceStore((state) => state.selectedMarket);

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="10px"
      paddingBottom="30px"
      width="100%"
      minWidth={0}
      maxWidth="100%"
    >
      <Box
        borderTop={1}
        borderColor="divider"
        sx={{ backgroundColor: "white" }}
        width="100%"
        minWidth={0}
        maxWidth="100%"
      >
        <Tabs
          value={selectedView}
          onChange={(_, value) => {
            setSelectedView(value);
          }}
          slotProps={{
            indicator: {
              style: {
                top: 0,
              },
            },
          }}
        >
          {tabItems.map(({ id, label }) => (
            <Tab
              key={id}
              id={id}
              data-testid={`workspace-view-${id}`}
              label={label}
            />
          ))}
        </Tabs>
      </Box>
      {selectedMarket && (
        <>
          {selectedView === ViewOption.MARKET_LANDSCAPE && <MarketLandscape />}
          {selectedView === ViewOption.COMPETITIVE_ANALYSIS && (
            <CompetitiveAnalysis />
          )}
          {selectedView === ViewOption.COMPANY_LIST && <CompanyList />}
        </>
      )}
    </Box>
  );
};
